import { ImportExportRounded } from "@mui/icons-material";
import { Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { useState } from "react";
import {
  CreateMetricModal,
  MetricsCollectionFilterButton,
  MetricsGrid,
  ReorderMetricCollectionModal,
} from "src/components";
import { useSession } from "src/hooks";
import { useUserPageLayoutContext } from "src/pages";
import { useUserMetricsSettings } from "./hooks";

const UserMetricsPage = () => {
  const { userId: sessionUserId } = useSession();
  const { user } = useUserPageLayoutContext();
  const { settings, updateSettings } = useUserMetricsSettings(user.userId);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [isReorderModalVisible, setIsReorderModalVisible] = useState(false);

  return (
    <>
      <Stack spacing={1}>
        <Card>
          <CardContent>
            <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
              <Stack spacing={0.5} sx={{ flexGrow: 1 }}>
                <Stack spacing={0.25}>
                  <Typography variant="h5">Metrics</Typography>
                  <Typography>Metrics you track and report</Typography>
                </Stack>

                {user.metricCount > 0 && (
                  <Stack direction="row" spacing={0.5}>
                    {sessionUserId === user.userId && (
                      <Button
                        variant="tertiary"
                        startIcon={<ImportExportRounded />}
                        onClick={() => setIsReorderModalVisible(true)}
                      >
                        Reorder
                      </Button>
                    )}

                    <MetricsCollectionFilterButton
                      variant="text"
                      metricCollectionGuid={user.metricCollectionGuid}
                      filters={settings.filters}
                      onFiltersChanged={(filters) => updateSettings({ filters })}
                    />
                  </Stack>
                )}
              </Stack>

              {sessionUserId === user.userId && (
                <Button variant="contained" onClick={() => setIsCreateModalVisible(true)}>
                  Add Metric
                </Button>
              )}
            </Stack>
          </CardContent>
        </Card>

        <MetricsGrid metricCollectionGuid={user.metricCollectionGuid} filters={settings.filters} />
      </Stack>

      <CreateMetricModal
        visible={isCreateModalVisible}
        onAdded={() => setIsCreateModalVisible(false)}
        onCancelled={() => setIsCreateModalVisible(false)}
      />

      <ReorderMetricCollectionModal
        visible={isReorderModalVisible}
        metricCollectionGuid={user.metricCollectionGuid}
        onSave={() => setIsReorderModalVisible(false)}
        onCancel={() => setIsReorderModalVisible(false)}
      />
    </>
  );
};

export { UserMetricsPage };
